<template>
  <div class="col-md-6 col-sm-12 align-left footer-bottom">
    Copyright&nbsp;
    <span><router-link class="no-link" to="/login">&copy;</router-link></span>
      &nbsp;<a href="https://cubeek.net">Jakub Stonavský</a>&nbsp;&amp;&nbsp;<a href="/">Oldtimers Garage</a>&nbsp;2018<br>
    All rights reserved.
    <api-check></api-check>
  </div>
</template>

<script>
import ApiCheck from '@/components/utils/ApiCheck'
export default {
  components: {
    ApiCheck
  }
}
</script>



// WEBPACK FOOTER //
// FooterCopyleft.vue?715937e7